import { Injectable } from "@angular/core";
import { Adapter } from "src/app/Interfaces/adapter";

export class Principal {
    constructor(
        public MasterID?: number,
        public StaffID?: number,
        public School?: string,
        public OrgUnit?: string,
        public SchoolType?: string,
        public PersonnelNumber?: string,
        public Principal?: string,
        public JobClass?: string,
        public JobClassNumber?: string,
        public PersonnelArea?: string,
        public PersonnelAreaCD?: string,
        public SapStaffIID?: number,
        public FirstName?: string,
        public LastName?: string,
        public Sap_PersonnelNumber?: string,
        public Sap_OrgUnit?: string,
        public Sap_JobClass?: string,
        public Sap_JobClassNumber?: string,
        public Status?: string
    ) {}
}

@Injectable({
    providedIn: 'root'
})

export class PrincipalAdapter implements Adapter<Principal> {
    adapt(item: any): Principal {
        return new Principal(
            item.MasterID,
            item.StaffID,
            item.School,
            item.OrgUnit,
            item.SchoolType,
            item.PersonnelNumber,
            item.Principal,
            item.JobClass,
            item.JobClassNumber,
            item.PersonnelArea,
            item.PersonnelAreaCD,
            item.SapStaffIID,
            item.FirstName,
            item.LastName,
            item.Sap_PersonnelNumber,
            item.Sap_OrgUnit,
            item.Sap_JobClass,
            item.Sap_JobClassNumber,
            item.Status
        )
    }
}